/** SPEC §2.3 — votes are bucketed by week; decay is a weight per bucket. */

/** Monday 2026-01-05 00:00 UTC, in unix seconds. */
export const EPOCH_ZERO = Date.UTC(2026, 0, 5) / 1000;
export const WEEK_SECONDS = 7 * 24 * 3600;
export const DEFAULT_HALF_LIFE_DAYS = 90;
/** Epochs older than this many weeks are deleted by the hydration job (§2.3, §8.5). */
export const RETENTION_WEEKS = 52;

export function epochOf(unixSeconds: number): number {
  return Math.floor((unixSeconds - EPOCH_ZERO) / WEEK_SECONDS);
}

export function decayWeight(epoch: number, nowEpoch: number, halfLifeDays = DEFAULT_HALF_LIFE_DAYS): number {
  const ageDays = Math.max(0, nowEpoch - epoch) * 7;
  return 2 ** (-ageDays / halfLifeDays);
}

/** Weight table for every live epoch — the `WITH w(epoch, f)` join table in §7.2. */
export function decayTable(nowEpoch: number, halfLifeDays = DEFAULT_HALF_LIFE_DAYS, weeks = RETENTION_WEEKS): Array<[epoch: number, f: number]> {
  const rows: Array<[number, number]> = [];
  for (let e = nowEpoch; e >= nowEpoch - weeks && e >= 0; e--) rows.push([e, decayWeight(e, nowEpoch, halfLifeDays)]);
  return rows;
}
